'use strict';

import { combinereducers } from 'redux';
import update from 'immutability-helper';
import * as types from './types';

export default (
    state = {
		date: null,
		list: [],
		lastUpdate: null,
	},
	action
) => {
	let selected, newSelected, locations, jobs, newList;

    switch (action.type) {

		case types.SET_LIST:
			return {
				...state,
				date: action.data.date,
				list: action.data.locations.map(l => ({
					...l,
					isChecked: false,
				})),
				lastUpdate: null,
			};

		case types.POST_ADD_TO_ROUTE_COMPLETED:
			return {
				...state,
				date: action.meta.params.date,
				list: action.data.assignments.locations.map(l => ({
					...l,
					isChecked: false,
				})),
				lastUpdate: {
					op: 'ADD_TO_ROUTE',
				},
			};

		case types.SELECT_ALL:
			return {
				...state,
				list: state.list.map(i => ({ ...i, isChecked: true })),
				lastUpdate: null,
			};

		case types.UNSELECT_ALL:
			return {
				...state,
				list: state.list.map(i => ({ ...i, isChecked: false })),
				lastUpdate: null,
			};

		case types.TOGGLE_SELECT:
			return {
				...state,
				list: state.list.map(
					(item, i) => i === action.data ?
						({
							...item,
							isChecked: !item.isChecked,
						}) :
						item
				),
				lastUpdate: null,
			};

		case types.MOVE_SELECTION:

			const lastIdx = state.list.length - 1;

			const selected = state.list.reduce(
				(sels, item, i) => {

					if (item.isChecked) {
						if (action.data.direction > 0 && i === lastIdx) {
							item.index = 0;
						} else if (action.data.direction < 0 && i === 0) {
							item.index = lastIdx;
						} else {
							item.index = i + action.data.direction;
						}

						return [ ...sels, item ];
					}

					return sels;
				},
				[]
			);

			const unselected = state.list.filter(i => !i.isChecked);

			const reordered = Array(state.list.length).fill(0).map((i, j) => {

				const next = selected.find(item => item.index === j);

				if (next) {
					const { index, ...rest } = next;
					return rest;
				}

				return unselected.shift();
			});

			return {
				...state,
				list: reordered,
				lastUpdate: null,
			};

		case types.REORDER_ASSIGNED:

			const { dragIndex, hoverIndex } = action.data;

			return {
				...state,
				list: update(
					state.list,
					{
						$splice: [
							[ dragIndex, 1 ],
							[ hoverIndex, 0, state.list[ dragIndex ] ]
						]
					}
				),
				lastUpdate: null,
			};

		case types.POST_FLAG_INCREMENT_COMPLETED:

			newList = [ ...state.list ];

			newList[ action.meta.body.index ].flag = action.data.flagValue;

			return {
				...state,
				list: newList,
				lastUpdate: {
					op: 'FLAG_INCREMENT',
					value: {
						index: action.meta.body.index,
					},
				},
			};

		case types.POST_PRIORITY_INCREMENT_COMPLETED:

			newList = [ ...state.list ];

			newList[ action.meta.body.index ].priority = action.data.priorityValue;

			return {
				...state,
				list: newList,
				lastUpdate: {
					op: 'PRIORITY_INCREMENT',
					value: {
						index: action.meta.body.index,
					},
				},
			};

		case types.POST_REORDERED_LOCATIONS_COMPLETED:

			return {
				...state,
				lastUpdate: {
					op: 'REORDERED_LOCATIONS',
				},
			};

		case types.POST_REVERSE_SELECTION_COMPLETED:

			const { selectedIndices } = action.meta.body;

			const lower = selectedIndices[ 0 ];
			const len = selectedIndices.length;
			const upper = selectedIndices[ len - 1 ];

			return {
				...state,
				list: [
					...state.list.slice(0, lower),
					...state.list.slice(lower, lower + len).reverse(),
					...state.list.slice(upper + 1)
				],
				lastUpdate: {
					op: 'REVERSE_SELECTION',
				},
			};

		case types.POST_OPTIMIZE_ROUTE_COMPLETED:

			({ locations } = action.data.assignments);

			const areChecked = state.list.reduce(
				(byId, l) => l.isChecked ?
					{ ...byId, [ l.locationId ]: true } :
					byId,
				{}
			);

			return {
				...state,
				list: locations.map(l => ({
					...l,
					isChecked: l.locationId in areChecked,
				})),
				lastUpdate: {
					op: 'OPTIMIZE_ROUTE'
				},
			};

		case types.POST_DELETE_LOCATIONS_COMPLETED:

			({ locations } = action.data.assignments);

			return {
				...state,
				list: locations.map(l => ({
					...l,
					isChecked: false,
				})),
				lastUpdate: {
					op: 'DELETE_ITEMS'
				},
			};

		default:
			return {
				...state,
				lastUpdate: null,
			};
	}
};
